/* eslint-disable
    @typescript-eslint/no-unused-vars,
    eqeqeq,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let DesktopNotification;
const { isDesktop } = require('@trello/browser');
const {
  currentModelManager,
} = require('app/scripts/controller/currentModelManager');
const EntityDisplay = require('app/scripts/lib/entity-display');
const Promise = require('bluebird');
const { TrelloStorage } = require('@trello/storage');
const _ = require('underscore');
const xtend = require('xtend');
const { dontDismissNotifications } = require('@trello/config');

const Notification =
  window.Notification != null ? window.Notification : { permission: 'denied' };

module.exports = DesktopNotification = (function () {
  let LOCK_DELAY = undefined;
  let PRIORITY_DELAY = undefined;
  let CLEAR_DELAY = undefined;
  let stringifyEntity = undefined;
  DesktopNotification = class DesktopNotification {
    static initClass() {
      // Amount of time to wait after writing lock to read it
      LOCK_DELAY = 100;
      // Head start to give 'priority' windows (i.e. ones displaying the board/org
      // the notification is about)
      PRIORITY_DELAY = 1000;
      // Amount of time to wait to clear the lock and notification
      CLEAR_DELAY = 10000;

      stringifyEntity = function (entity) {
        switch (entity.type) {
          case 'relDate':
            return entity.current;
          case 'comment':
          case 'attachmentPreview':
            return '';
          default:
            return entity.text;
        }
      };
    }

    static enabled() {
      return Notification.permission === 'granted';
    }
    static denied() {
      return Notification.permission === 'denied';
    }
    static notEnabled() {
      return Notification.permission === 'default';
    }
    static requestPermission() {
      return new Promise(function (resolve, reject) {
        const reqPerm = Notification.requestPermission;
        if (!reqPerm) {
          return reject('denied');
        } else {
          return reqPerm(function (result) {
            if (result === 'denied') {
              return reject(result);
            } else {
              return resolve(result);
            }
          });
        }
      });
    }

    constructor(model) {
      this.model = model;
      if (
        (!DesktopNotification.enabled() && !window.fluid) ||
        !this.model.get('unread')
      ) {
        return;
      }

      // If the board is open somewhere in a tab, we want to give that tab first
      // dibs on displaying the notification so that it can load in that tab if
      // clicked.
      if (this.localNotification()) {
        this.show();
      } else {
        setTimeout(this.show.bind(this), PRIORITY_DELAY);
      }
    }

    show() {
      if (this.model.get('type') === 'reactionAdded') {
        return;
      }

      return this.getLock(() => {
        const { title, body, icon, tag } = this.render();

        if (window.fluid) {
          // If you're using Trello in Fluid, use Growl notifications
          return window.fluid.showGrowlNotification({
            title,
            priority: 1,
            sticky: false,
            description: body,
            icon,
          });
        } else {
          // Normal browser notifications
          const n = new Notification(title, { body, icon, tag });
          n.model = this.model;
          n.addEventListener('click', this.clickHandler.bind(this));

          if (!dontDismissNotifications) {
            return setTimeout(() => {
              return n.close();
            }, CLEAR_DELAY);
          }
        }
      });
    }

    render() {
      const entities = new EntityDisplay('notification').getEntities(
        this.model.getDisplay(),
      );

      const title = _.chain(entities)
        .map(stringifyEntity)
        .compact()
        .value()
        .join('')
        .trim();

      const commentEntity = _.find(entities, (e) => e.type === 'comment');
      const body = commentEntity != null ? commentEntity.text : '';

      const member = this.model.getMember();
      let icon = '/favicon.ico';
      if (member != null ? member.avatarUrl : undefined) {
        icon = [member.avatarUrl, '50.png'].join('/');
      }

      const tag = this.model.id;

      return { title, body, icon, tag };
    }

    clickHandler(event) {
      const data = this.model.get('data');
      this.model.markRead();
      event.target.close();

      const url = this.model.getUrlOfTarget();

      const newTab = window.open(url);
      // Electron window.open doesn't return correctly even though window.open
      // succeeds so this keeps us from navigating and opening a new window
      if (!isDesktop()) {
        if (newTab != null) {
          return newTab.focus();
        } else {
          return window.location.assign(url);
        }
      }
    }

    localNotification() {
      const data = this.model.get('data');
      return _.any(
        _.invoke(
          [
            () =>
              currentModelManager.onBoardView(
                data.board != null ? data.board.id : undefined,
              ),
            () =>
              currentModelManager.onOrganizationView(
                data.organization != null ? data.organization.id : undefined,
              ),
          ],
          'call',
        ),
      );
    }

    // Try to get a lock for displaying the notification to prevent multiple tabs
    // from displaying the same one, and call the callback if successful.
    getLock(next) {
      const key = `notification_lock_${this.model.id}`;

      // Check if another tab is displaying this notification.
      if (TrelloStorage.get(key)) {
        return;
      }

      // We may be competing with other tabs for this write, so each tab will
      // attempt to write with a unique key, wait a small delay for contention,
      // and then try to read to see if it obtained the lock or not.
      const uniqueValue = Math.random();
      TrelloStorage.set(key, uniqueValue);

      // Check if we obtained the lock and call the callback only if we did.
      setTimeout(() => {
        if (TrelloStorage.get(key) === uniqueValue) {
          return next();
        }
      }, LOCK_DELAY);

      // Clean up our key after a small delay.
      return setTimeout(() => {
        return TrelloStorage.unset(key);
      }, CLEAR_DELAY);
    }
  };
  DesktopNotification.initClass();
  return DesktopNotification;
})();
